import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CloseOutlined } from '@ant-design/icons';

interface ModalProps {
  isModalOpen: boolean;  // Changed from 'open' to match your usage
  closeModal: () => void;  // Changed from 'onClose' to match your usage
  setIsModalOpen?: (value: boolean) => void;  // Added to match your usage
  children: React.ReactNode;
  shouldHandleOutsideClick?: boolean;
  darkBackground?: boolean;
  isCentered?: boolean;
  className?: string;
}

const ARParentalModal = ({
  isModalOpen,  // Changed from 'open'
  closeModal,  // Changed from 'onClose'
  setIsModalOpen,  // Added
  children,
  shouldHandleOutsideClick = true,
  darkBackground = true,
  isCentered = true,
  className = ''
}: ModalProps) => {
  return (
    <Transition show={isModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={shouldHandleOutsideClick ? closeModal : () => {}}
      >
        {darkBackground && (
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>
        )}

        <div className="fixed inset-0 overflow-y-auto">
          <div className={`flex ${isCentered ? 'min-h-full items-center justify-center' : ''} p-4 text-center`}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className={`max-w-xxl transform overflow-hidden bg-white p-6 text-left align-middle shadow-xl transition-all ${className}`}>
                <button
                  onClick={closeModal}
                  className="flex items-center justify-center absolute right-4 top-4 rounded-full p-2 hover:bg-gray-100 transition-colors"
                >
                  <CloseOutlined className="h-4 w-4 text-gray-500" />
                </button>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ARParentalModal;